import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import { forwardRef } from "@chakra-ui/system";
import { Box } from "../Box/Box";

export const CopyToClipboard: FC<JSX.IntrinsicAttributes> = forwardRef(
  (props, ref) => (
    <Box as="span" ref={ref}>
      <FontAwesomeIcon icon={faCopy} {...props} />
    </Box>
  )
);
